import axios from "axios";

const https = axios.create({
        baseURL: 'http://39.100.116.104:30003',
        headers: {},
        timeout:30000
    })
    /**
     * 请求拦截
     */
https.interceptors.request.use(config => {
    let userMap = JSON.parse(window.sessionStorage.getItem('LOGIN'))
    if (userMap != null) {
        config.headers = {
            'USERNAME': userMap.USERNAME,
            'DEPTNO': userMap.DEPTNO,
            'ROLELEVE': userMap.ROLE_LEVE,
            'USERID': userMap.USER_ID,
        }
    }
    return config
}, error => {
    // 请求错误可以提交commit
    return Promise.reject(err);
})

export default https


// WEBPACK FOOTER //
// ./src/components/utils/https.js